import * as React from 'react';
import { SVGProps } from 'react';

export const CommentIconSVG = (props: { active?: boolean } & SVGProps<SVGSVGElement>) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.76592 17.9497L8.54362 17.712H8.21821H5.4C3.43064 17.712 1.75 15.9898 1.75 13.7586V6.70344C1.75 4.47228 3.43064 2.75 5.4 2.75H18.6C20.5694 2.75 22.25 4.47228 22.25 6.70344V13.7586C22.25 15.9898 20.5694 17.712 18.6 17.712H15.7818H15.4589L15.237 17.9466L12.212 21.1437L12.2097 21.1461C12.0746 21.2902 11.8887 21.2881 11.7575 21.1475L11.7568 21.1468L8.76592 17.9497ZM11.4523 19.6353L12 20.2207L12.5477 19.6353L15.0554 16.9546C15.0556 16.9544 15.0557 16.9543 15.0559 16.9541C15.1053 16.9018 15.1917 16.8603 15.3 16.8603H18.6C20.276 16.8603 21.55 15.4242 21.55 13.7586V6.70344C21.55 5.0378 20.276 3.60172 18.6 3.60172H5.4C3.72396 3.60172 2.45 5.0378 2.45 6.70344V13.7586C2.45 15.4242 3.72396 16.8603 5.4 16.8603H8.7C8.81124 16.8603 8.89518 16.9018 8.94319 16.9531L11.4523 19.6353ZM6.15 7.8793C6.15 7.59654 6.35334 7.45344 6.5 7.45344H17.5C17.6467 7.45344 17.85 7.59654 17.85 7.8793C17.85 8.16206 17.6467 8.30516 17.5 8.30516H6.5C6.35334 8.30516 6.15 8.16206 6.15 7.8793ZM6.15 12.5827C6.15 12.3 6.35334 12.1569 6.5 12.1569H14.2C14.3467 12.1569 14.55 12.3 14.55 12.5827C14.55 12.8655 14.3467 13.0086 14.2 13.0086H6.5C6.35334 13.0086 6.15 12.8655 6.15 12.5827Z"
            stroke={props.active ? '#01AAB9' : '#637488'}
            strokeWidth="1.5"
        />
    </svg>
);
